import { useEffect } from 'react'
import { useLocation, useNavigationType } from 'react-router-dom'

// ScrollToTop
// -----------
// React Router does not automatically scroll to the top of the page on
// route changes (it preserves the browser's natural scroll position).
// That's fine when the new page is short, but it's broken UX when a user
// clicks a footer link (they're at the bottom of the current page) and
// lands at the bottom of the new page with the header off-screen.
//
// This component fixes that: on every PUSH or REPLACE navigation, it
// scrolls to the top. It deliberately does NOT scroll on POP navigations
// (browser back/forward), because in those cases the user expects to
// land at the scroll position they had before. Forcing them to the top
// on back-navigation is worse than the original bug.
//
// Renders nothing. Lives inside <BrowserRouter> in App.js so it can
// read the current location and navigation type.

export default function ScrollToTop() {
  const { pathname } = useLocation()
  const navigationType = useNavigationType()  // 'PUSH', 'REPLACE', or 'POP'

  useEffect(() => {
    if (navigationType === 'POP') return  // browser back/forward: preserve position
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  }, [pathname, navigationType])

  return null
}
